/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function TagEntityActionsRepresentationFromJSON(json) {
    return TagEntityActionsRepresentationFromJSONTyped(json, false);
}
export function TagEntityActionsRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        canUpdate: json['canUpdate'],
        canDelete: json['canDelete'],
        isOwner: json['isOwner'],
    };
}
export function TagEntityActionsRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        canUpdate: value.canUpdate,
        canDelete: value.canDelete,
        isOwner: value.isOwner,
    };
}
